import React, {useEffect} from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';
import s from './Total.scss';
import cx from 'clsx';

export enum TotalDataHook {
  Title = 'Total.Title',
  Value = 'Total.Value',
}

export const Total = () => {
  const {t} = useTranslation();
  const {shouldDisplaySubtotalTitle} = useControllerProps().orderStore;
  const {cartSummary, pageLoaded, cartModel, refactorCouponOnCart} = useControllerProps().cartStore;

  const classNames = cx(s.root, {[s.subTotal]: shouldDisplaySubtotalTitle});

  useEffect(
    () => {
      pageLoaded();
    },
    /* eslint-disable react-hooks/exhaustive-deps*/ []
  );

  return (
    <dl className={classNames}>
      <dt>
        <span id="subtotal-label" data-hook={TotalDataHook.Title}>
          {shouldDisplaySubtotalTitle ? t('cart.subtotal') : t('cart.estimated_total')}
        </span>
      </dt>

      <dd
        data-hook={TotalDataHook.Value}
        role="status"
        aria-live="polite"
        id="total-sum"
        aria-labelledby="subtotal-label"
        data-wix-cart-total-price={TotalDataHook.Value}>
        {cartSummary?.priceSummary.total.formattedConvertedAmount ??
          (refactorCouponOnCart
            ? cartModel.subtotal.formattedConvertedAmount
            : cartModel.subtotalAfterDiscounts.formattedConvertedAmount)}
      </dd>
    </dl>
  );
};
